'use client';

import { Stack } from '@chakra-ui/react';
import { IProduct } from '@/entities/product/model/types';
import { ICartItem } from '@/_store/types';
import BrandHeader from './BrandHeader';
import ProductThumbnails from './ProductThumbnails';
import BrandActionButtons from './BrandActionButtons';

interface BrandCartCardProps {
  products: ICartItem[];
  onClear: () => void;
  onRestaurant: () => void;
  onCheckout: () => void;
  brandName: string;
  onClosePopover: () => void;
}

export default function BrandCartCard({
  products,
  onClear,
  onRestaurant,
  onCheckout,
  brandName,
  onClosePopover,
}: BrandCartCardProps) {
  return (
    <Stack
      px={4}
      py={4}
      gap={0}
      h='full'
      rounded={16}
      bg='white'
      align='start'
      justifyContent='space-between'
    >
      <BrandHeader brandName={brandName} onClear={onClear} />
      <ProductThumbnails products={products} />
      <BrandActionButtons
        onRestaurant={onRestaurant}
        onCheckout={onCheckout}
        onClosePopover={onClosePopover}
      />
    </Stack>
  );
}
